import { render } from "./CalendarWidget.vue?vue&type=template&id=5ad4c634&scoped=true"
import script from "./CalendarWidget.vue?vue&type=script&lang=ts"
export * from "./CalendarWidget.vue?vue&type=script&lang=ts"

import "./CalendarWidget.vue?vue&type=style&index=0&id=5ad4c634&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ad4c634"

export default script